module.exports = __webpack_public_path__ + "fa-brands-400.eot?592643a83b8541edc52063d84c468700";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/webfonts/fa-brands-400.eot
// module id = 326
// module chunks = 0